/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import { Config } from "../../../utils/config";
import DeliveryCart from "./DeliveryCart";
import DinInCart from "./DinInCart";
import PickUpCart from "./PickUpCart";
import TableReservationCart from "./TableReservationCart";
import { SkeletonLoading } from "../../../components/Skeleton";

export default function CartAccordionItem3({
  orderingMethod,
  cartList,
  authToken,
  restaurantDetail,
  id,
  handleCartList,
  handleAccordionClick,
}) {
  const { t } = useTranslation();
  const ordering_method = cartList?.orderingMethod?.ordering_method;

  const [isLoading, setIsLoading] = useState(false);

  // Track ordering method changes and show skeleton loading
  useEffect(() => {
    if (!ordering_method) return;

    // Show skeleton whenever ordering method changes
    setIsLoading(true);

    // Set a timeout to hide the skeleton after a delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    // Clean up the timer if component unmounts or ordering_method changes again
    return () => clearTimeout(timer);
  }, [ordering_method]);

  return (
    <AccordionItem value="item-3" disabled={cartList?.orderingMethod === null}>
      <AccordionTrigger>
        {Config.env.app.ordering_method_type.map((item, index) => {
          if (orderingMethod === item.value) {
            return (
              <div key={index} className="flex space-x-3">
                <div>
                  <item.icon />
                </div>
                <div>{t(item.title)}</div>
              </div>
            );
          }
          return null;
        })}
      </AccordionTrigger>

      {isLoading ? (
        <SkeletonLoading />
      ) : (
        <>
          {ordering_method === "pickup" && (
            <PickUpCart
              cartList={cartList}
              authToken={authToken}
              id={id}
              restaurantDetail={restaurantDetail}
              handleCartList={handleCartList}
              handleAccordionClick={handleAccordionClick}
            />
          )}
          {ordering_method === "delivery" && (
            <DeliveryCart
              cartList={cartList}
              authToken={authToken}
              id={id}
              restaurantDetail={restaurantDetail}
              handleCartList={handleCartList}
              handleAccordionClick={handleAccordionClick}
            />
          )}
          {(ordering_method === "table_reservation" ||
            ordering_method === "in_restaurant") && (
            <TableReservationCart
              cartList={cartList}
              authToken={authToken}
              id={id}
              restaurantDetail={restaurantDetail}
              handleCartList={handleCartList}
              handleAccordionClick={handleAccordionClick}
            />
          )}
          {ordering_method === "dine_in" && (
            <DinInCart
              cartList={cartList}
              authToken={authToken}
              id={id}
              restaurantDetail={restaurantDetail}
              handleCartList={handleCartList}
              handleAccordionClick={handleAccordionClick}
            />
          )}
        </>
      )}
    </AccordionItem>
  );
}
